export function initHeader() {

  // KEYBOARD ACTIVATION FOR role="button" ELEMENTS ------------------------------
  // Lets div-based controls respond to Enter / Space like a native button.

  function enableKeyActivation(el){
    el.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        el.click();
      }
    });
  }

  document.querySelectorAll('.header__item[role="button"]').forEach(enableKeyActivation);


  // HEADER MENU INTERACTION ------------------------------------------------------------

  const openMenus  = document.querySelectorAll('[data-open="header__menu"]');
  const closeMenus = document.querySelectorAll('[data-close="header__menu"]');
  const menu       = document.querySelector('.header__menu');

  let menuTrigger = null; // element that opened the menu, to restore focus on close

  // Focusable elements helper for the focus trap.
  function getFocusable(container){
    return Array.from(container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(el => el.offsetParent !== null);
  }

  function trapFocus(e){
    if (e.key !== 'Tab' || !menu.classList.contains('_open')) return;

    const focusable = getFocusable(menu);
    if (!focusable.length) return;

    const first = focusable[0];
    const last  = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function setExpanded(state){
    openMenus.forEach(btn => {
      if (btn.hasAttribute('aria-expanded')) btn.setAttribute('aria-expanded', state);
    });
  }

  function openMenu(trigger){
    menuTrigger = trigger || null;
    menu.classList.add('_open');
    setExpanded('true');

    setTimeout(() => {
      const input = document.querySelector('.header__menu__search input');
      const focusable = getFocusable(menu);
      (window.innerWidth >= 1200 && input ? input : focusable[0])?.focus();
    }, window.innerWidth >= 1200 ? 500 : 50);
  }

  function closeMenu(){
    menu.classList.add('_closing');
    setExpanded('false');

    setTimeout(() => {
      menu.classList.remove('_closing');
      menu.classList.remove('_open');
    }, 500);

    menuTrigger?.focus();
    menuTrigger = null;
  }

  if (menu) {

    openMenus.forEach(btn => {
      btn.addEventListener('click', () => openMenu(btn));
    });

    closeMenus.forEach(btn => {
      btn.addEventListener('click', () => closeMenu());
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && menu.classList.contains('_open')) {
        closeMenu();
      }
      trapFocus(e);
    });

  }


  // ITEM TOGGLE ----------------------------------------------------

  const profiles = document.querySelectorAll(".header__item--profiles");

  function setProfileExpanded(profile, state){
    if (profile.hasAttribute('aria-expanded')) {
      profile.setAttribute('aria-expanded', state ? 'true' : 'false');
    }
  }

  profiles.forEach(profile => {
    profile.addEventListener("click", function (e) {
      e.stopPropagation();

      // cerrar otros si existen
      profiles.forEach(p => {
        if (p !== profile) {
          p.classList.remove("_open");
          setProfileExpanded(p, false);
        }
      });

      const willOpen = !profile.classList.contains("_open");
      profile.classList.toggle("_open");
      setProfileExpanded(profile, willOpen);
    });
  });

  document.addEventListener("click", function () {
    profiles.forEach(profile => {
      profile.classList.remove("_open");
      setProfileExpanded(profile, false);
    });
  });


  // HEADER NESTED PAGES COLLAPSE/FILTERING -----------------------------------------------------

  const nav = document.querySelector('.header__menu__nav');
  const searchInput = document.querySelector('.header__menu__search input');
  const resetBtn = document.querySelector('.search__reset');

  if (!nav) return;

  const items = nav.querySelectorAll('li');

  // mensaje "no results"
  const message = document.createElement('div');
  message.className = 'message';
  message.textContent = 'Presiona enter para buscar';
  message.style.display = 'none';
  nav.appendChild(message);

  // normalizar texto (sin tildes)
  const normalize = str =>
    str.toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

  function restoreExternalIcon(link){
    if (link.dataset.external === '1' && !link.querySelector('.icon--external')) {
      const icon = document.createElement('span');
      icon.className = 'icon icon--target icon--external';
      link.append(icon);
    }
  }

  function resetMenu(){

    nav.classList.remove('_filtered');
    message.style.display = 'none';

    items.forEach(li => {

      const link = li.querySelector(':scope > a');
      if (!link) return;

      const original = link.dataset.original;

      link.innerHTML = original;

      restoreExternalIcon(link);

      li.style.display = '';
      li.classList.remove('_open');

    });

  }

  // construir menú inicial
  items.forEach(li => {

    const subMenu = li.querySelector(':scope > ul');
    const link = li.querySelector(':scope > a');

    if (!link) return;

    link.dataset.original = link.textContent.trim();

    const isExternal = link.getAttribute('target') === '_blank';
    link.dataset.external = isExternal ? '1' : '';

    if (isExternal) {

      const icon = document.createElement('span');
      icon.className = 'icon icon--target icon--external';
      link.append(icon);

    }

    if (subMenu) {

      const toggle = document.createElement('div');
      toggle.className = 'header__menu__collapse';

      li.insertBefore(toggle, link);

      toggle.addEventListener('click', e => {

        e.preventDefault();
        e.stopPropagation();

        const isOpen = li.classList.contains('_open');

        // cerrar hermanos
        const siblings = li.parentElement.querySelectorAll(':scope > li');

        siblings.forEach(sibling => {

          if (sibling !== li) {
            sibling.classList.remove('_open');

            // cerrar también descendientes abiertos
            sibling.querySelectorAll('li._open').forEach(child=>{
              child.classList.remove('_open');
            });

          }

        });

        // toggle del actual
        if (!isOpen) {
          li.classList.add('_open');
        } else {
          li.classList.remove('_open');
        }

      });
    }

  });

  if (!searchInput) return;

  // BUSQUEDA
  searchInput.addEventListener('input', () => {

    const term = normalize(searchInput.value.trim());

    if (resetBtn) {
      resetBtn.style.display = term ? 'block' : 'none';
    }

    resetMenu();

    if (!term) return;

    nav.classList.add('_filtered');

    let results = 0;

    items.forEach(li => {

      const link = li.querySelector(':scope > a');
      if (!link) return;

      const original = link.dataset.original;
      const normalizedText = normalize(original);

      const index = normalizedText.indexOf(term);

      if (index !== -1) {

        results++;

        const before = original.substring(0, index);
        const match = original.substring(index, index + term.length);
        const after = original.substring(index + term.length);

        link.innerHTML =
          `${before}<strong class="match">${match}</strong>${after}`;

        restoreExternalIcon(link);

        li.style.display = '';

        // abrir padres
        let parent = li.parentElement.closest('li');

        while (parent) {

          parent.style.display = '';
          parent.classList.add('_open');

          parent = parent.parentElement.closest('li');

        }

        // mostrar hijos si hay
        const children = li.querySelectorAll('ul li');

        children.forEach(child=>{
          child.style.display = '';
        });

        if (li.querySelector(':scope > ul')){
          li.classList.add('_open');
        }

      } else {

        li.style.display = 'none';

      }

    });

    // mostrar mensaje si no hay resultados
    message.style.display = results === 0 ? 'block' : 'none';

  });

  // RESET BUTTON
  if (resetBtn){

    resetBtn.addEventListener('click', e => {

      e.preventDefault();

      searchInput.value = '';

      resetBtn.style.display = 'none';

      resetMenu();

      searchInput.focus();

    });

  }

}